import React, { useState, useRef } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Banner3D } from "@/components/site/Banner3D";
import { Services } from "@/components/site/Services";
import { Pricing } from "@/components/site/Pricing";
import { Gallery } from "@/components/site/Gallery";
import { ServiceArea } from "@/components/site/ServiceArea";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { FloatingBar, WhatsAppFab } from "@/components/site/FloatingBar";

const SERVICE_MAP = {
  flex: "Flex Printing",
  vinyl: "Vinyl Printing",
  sunboard: "Sun Board",
  led: "LED Name Board",
};

export default function Landing() {
  const [preset, setPreset] = useState("");
  const quoteRef = useRef(null);

  const goToQuote = (serviceId) => {
    if (serviceId && SERVICE_MAP[serviceId]) setPreset(SERVICE_MAP[serviceId]);
    quoteRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Banner3D />
        <Services onQuote={goToQuote} />
        <Pricing onQuote={() => goToQuote()} />
        <Gallery />
        <ServiceArea />
        <QuoteForm ref={quoteRef} presetService={preset} />
      </main>
      <Footer />
      <FloatingBar />
      <WhatsAppFab />
    </div>
  );
}
